export default {

    apiUrl: '/api',
    munisenseApiUrl: 'https://avecodebondt.water-munisense.net/webservices/v2',
    loginUrl: 'https://beheer.avecodebondt.nl/login?app=loggers',
    mijnAvecoUrl: 'https://beheer.avecodebondt.nl/',

    apps: [
        { id: 'mijn-aveco', name: 'Mijn Aveco de Bondt', url: 'https://beheer.avecodebondt.nl' },
        { id: 'monitor', name: 'Monitoringsplatform', url: 'https://omgevingsmonitoring.avecodebondt.nl' },
        { id: 'veldwerkwinkel', name: 'Veldwerkwinkel', url: 'https://veldwerkwinkel.avecodebondt.nl' },
        { id: 'loggers', name: 'Loggerdatabase', url: 'https://loggers.avecodebondt.nl' },
        { id: 'veldwerkdata', name: 'Veldwerkdata', url: 'https://veldwerkwinkel.avecodebondt.nl' },
    ]
}
